import { Quality, Value, listValues } from '@kudos/http-client'
import { Selectable } from '@shared/filters/selections'
import { useTranslatedField } from '@shared/utils/useTranslatedField'
import { useQuery } from '@tanstack/react-query'
import { useEffect, useState } from 'react'

const useQualities = (enabled: boolean = true, valueIdIn: string[] = []) => {
  const [qualities, setQualities] = useState<Selectable[]>()
  const getTranslatedField = useTranslatedField()
  const { data: values, isFetched } = useQuery({
    queryKey: ['listValuesAndQualities'],
    queryFn: () =>
      listValues({
        idIn: valueIdIn,
        embeds: ['qualities'],
      }),
    enabled,
  })

  const mapQualitySelectable = (value: Value, quality: Quality) => {
    const selectable: Selectable = {
      id: quality.id,
      name: getTranslatedField(quality, 'name'),
      color: value.color,
      tooltipValue: getTranslatedField(value, 'name'),
    }
    return selectable
  }

  useEffect(() => {
    // React Query returns cached data for the shared ['listValuesAndQualities']
    // key even when this hook is disabled (e.g. an award type with
    // qualitiesEnabled = false). Without this guard those stale qualities leak
    // into the send/refinement flow and get applied to the award (SYN-7321).
    if (!enabled) {
      setQualities([])
      return
    }
    if (!!values) {
      setQualities(
        values.flatMap(
          value => value.qualities?.map(quality => mapQualitySelectable(value, quality)) ?? [],
        ),
      )
    }
  }, [enabled, isFetched, values])

  return { qualities, isFetched }
}

export default useQualities
